import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge41 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='リソルグループのゴルフ会員権とは？' fontWeight={700} />
                <p>
                    リソルグループとは、株式会社リソルホールディングスが運営するゴルフ場グループです。
                    <br />
                    全国に約20コースを展開しており、東急不動産からの取得や関西カントリークラブの取得など、積極的なM&amp;Aによってコース数を拡大してきました。
                </p>
                <div className={s.h4_link}>・真名カントリークラブ（千葉県）</div>
                <div className={s.h4_link}>・入間カントリークラブ（埼玉県）</div>
                <div className={s.h4_link}>・北武蔵カントリークラブ（埼玉県）</div>
                <div className={s.h4_link}>・益子カントリー倶楽部（栃木県）</div>
                <div className={s.h4_link}>・スパ＆ゴルフリゾート久慈（茨城県）</div>
                <p>※上記は代表的なコースの一部です。すべての運営コースについては公式サイトをご確認ください。</p>
            </section>

            <section className={s.section}>
                <Heading2 title='リソルグループのゴルフ会員権の特典とは？' fontWeight={700} />
                <Heading3 title='リソルカードG' />
                <p>
                    リソルグループでは「リソルカードG」という共通ポイント会員証が用意されており、利用料金100円につき1ポイントが貯まります。
                    <br />
                    誕生月には100ポイントのボーナスが付与されるほか、対象ゴルフ場13施設・ホテル20施設で共通して利用できる点が特徴です。
                    <br />
                    ※特典内容・対象施設数は変更される場合がありますので、最新情報は公式サイトでご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='リソルグループのおすすめのゴルフ場は？' fontWeight={700} />
                <p>
                    リソルグループのゴルフ場一覧は
                    <a href='https://juchi.jp/courses?series_id=31' className={s.link}>
                        こちら
                    </a>
                    よりご確認ください。
                </p>
                <Heading3 title='リソルグループのコースをご紹介' />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/114'>真名カントリークラブ</a>
                </div>
                千葉県茂原市にある45ホールの庭園コースで、ゲーリー・プレーヤー設計のコースも備えています。
                <br />
                ※現在、名義書換の受付を停止しているため、購入をご検討の際は事前にご確認ください。
                <br />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/120'>入間カントリークラブ</a>
                </div>
                埼玉県越生町にある18ホールの丘陵コースで、越生梅林の近くに位置し、都心から1時間以内でアクセスできます。
                <br />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/1418'>北武蔵カントリークラブ</a>
                </div>
                埼玉県本庄市にある18ホールの丘陵コースで、都心から車で約60分、関越道の本庄児玉ICから約15分の立地です。
                <br />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/200'>益子カントリー倶楽部</a>
                </div>
                栃木県益子町にある27ホールのコースで、平坦で攻めやすい丘陵レイアウトが特徴です。
                <br />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/231'>スパ＆ゴルフリゾート久慈</a>
                </div>
                茨城県常陸太田市にある18ホールのコースで、ベントのワングリーンと7つの池が戦略性を高めています。
                <br />
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    リソルグループは全国各地にコースを展開しており、共通ポイント制度も用意されているため、複数コースを利用したい方から人気を集めています。
                    <br />
                    <br />
                    具体的なコースの特徴や売買状況については、お気軽に弊社にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge41;
